module.exports = __webpack_public_path__ + "static/img/avatar-bar.85267cbe.webp";